import { __awaiter } from "tslib";
import debug from 'debug';
import React from 'react';
import ReactDOM from 'react-dom';
import { Reset } from 'styled-reset';
import { createGlobalStyle } from 'styled-components';
import { App } from './app';
import { WebTerminal } from './web-terminal';
require('barretenberg-es/wasm/barretenberg.wasm');
const GlobalStyle = createGlobalStyle `
  #root {
    height: 100vh;
    overflow: hidden;
  }

  * {
    box-sizing: border-box;
  }
`;
function main() {
    return __awaiter(this, void 0, void 0, function* () {
        debug.enable('bb:*');
        const app = new App();
        ReactDOM.render(React.createElement(React.Fragment, null,
            React.createElement(Reset, null),
            React.createElement(GlobalStyle, null),
            React.createElement(WebTerminal, { app: app })), document.getElementById('root'));
    });
}
// tslint:disable-next-line:no-console
main().catch(console.error);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEtBQUssTUFBTSxPQUFPLENBQUM7QUFDMUIsT0FBTyxLQUFLLE1BQU0sT0FBTyxDQUFDO0FBQzFCLE9BQU8sUUFBUSxNQUFNLFdBQVcsQ0FBQztBQUNqQyxPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0sY0FBYyxDQUFDO0FBQ3JDLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ3RELE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxPQUFPLENBQUM7QUFDNUIsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBQzdDLE9BQU8sQ0FBQyx3Q0FBd0MsQ0FBQyxDQUFDO0FBRWxELE1BQU0sV0FBVyxHQUFHLGlCQUFpQixDQUFBOzs7Ozs7Ozs7Q0FTcEMsQ0FBQztBQUVGLFNBQWUsSUFBSTs7UUFDakIsS0FBSyxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQztRQUNyQixNQUFNLEdBQUcsR0FBRyxJQUFJLEdBQUcsRUFBRSxDQUFDO1FBQ3RCLFFBQVEsQ0FBQyxNQUFNLENBQ2I7WUFDRSxvQkFBQyxLQUFLLE9BQUc7WUFDVCxvQkFBQyxXQUFXLE9BQUc7WUFDZixvQkFBQyxXQUFXLElBQUMsR0FBRyxFQUFFLEdBQUcsR0FBSSxDQUN4QixFQUNILFFBQVEsQ0FBQyxjQUFjLENBQUMsTUFBTSxDQUFDLENBQ2hDLENBQUM7SUFDSixDQUFDO0NBQUE7QUFFRCxzQ0FBc0M7QUFDdEMsSUFBSSxFQUFFLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQyJ9